/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PartBrooding {
  None = 'NONE',
  Manual = 'MANUAL',
  Auto = 'AUTO'
}
